import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Text } from "@fluentui/react";
import * as React from "react";
import type { LtlFormCapabilities } from "@src/types/api";
import { styles as ltlPanelStyles } from "@taskpane/components/ltl/LTL.styles";
import { styles } from "./FTL.styles";

export function FtlShipmentDetailsHeading({
  bolCaps,
  detailsSectionTab,
  onShipmentTab,
  onBolTab,
}: {
  bolCaps: LtlFormCapabilities | null | undefined;
  detailsSectionTab: "shipment" | "bol";
  onShipmentTab: () => void;
  onBolTab: () => void;
}): React.ReactElement {
  if (bolCaps) {
    return (
      <>
        <Stack direction="row" sx={ltlPanelStyles.sectionTabs} role="tablist">
          <Box
            component="button"
            type="button"
            role="tab"
            aria-selected={detailsSectionTab === "shipment"}
            sx={
              detailsSectionTab === "shipment"
                ? { ...ltlPanelStyles.sectionTab, ...ltlPanelStyles.sectionTabActive }
                : ltlPanelStyles.sectionTab
            }
            onClick={onShipmentTab}
          >
            <Text variant="medium" styles={styles.sectionTitle}>
              SHIPMENT DETAILS
            </Text>
          </Box>
          <Box
            component="button"
            type="button"
            role="tab"
            aria-selected={detailsSectionTab === "bol"}
            sx={
              detailsSectionTab === "bol"
                ? { ...ltlPanelStyles.sectionTab, ...ltlPanelStyles.sectionTabActive }
                : ltlPanelStyles.sectionTab
            }
            onClick={onBolTab}
          >
            <Text variant="medium" styles={styles.sectionTitle}>
              BOL DETAILS
            </Text>
          </Box>
        </Stack>
        <Box sx={styles.divider} />
      </>
    );
  }
  return (
    <>
      <Text variant="medium" styles={styles.sectionTitle}>
        SHIPMENT DETAILS
      </Text>
      <Box sx={styles.divider} />
    </>
  );
}
